import { AxInit, ModuleName } from "../../../Lib/AxSystem/AxInit";
import { AxProdBookingInit } from "../Abstraction/AxBooking";
import { AxBooking } from "../Abstraction/AxBooking";
import { IAddToCartRequest } from "../../../Models/Tickets/IAddToCartRequest";
import { TimeSlotKeyDto } from "../../../Models/Reservation/TimeSlotKeyDto";

@ModuleName("AxProdBooking")
export class AxProdBooking extends AxBooking implements AxInit {
    constructor() { super(); }

    AxInit(initData: AxProdBookingInit): void {
        this.Init(initData);
    }

    AddToCart(): void {
        let requestObj: IAddToCartRequest = {
            Date: this.selectedDate,
            ProjNr: this.productSelection.ProjNr,
            PoolNr: this.productSelection.ProductGroupIdentifier,
            TicketTypeId: this.productSelection.Id,
            PersonTypes: [],
            TimeSlotKeys: []
        };

        for (let timeSlot of this.selectedTimeSlots) {
            requestObj.TimeSlotKeys.push(new TimeSlotKeyDto(timeSlot.timeSlotKey));
        }

        for (let prod of this.productSelection.ProductList) {
            if (prod.Quantity > 0) {
                requestObj.PersonTypes.push({
                    PersonTypeId: prod.SubProductIdentifier,
                    Quantity: prod.Quantity
                });
            }
        }

        this._summaryRedirect.redirect(this.postURL, requestObj, true);
    }
}
